import { useTenant } from '@emerald-works-nova/auth'
import { Box, Typography, Grid } from '@mui/material'
import { useStyles } from './style'
import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import consts from '../../../consts'
import { useExternalApp } from '../../../hooks'
import { contentSlice } from '../../../reducers'
import { ActionButton } from '../../action-buttons'
import clsx from 'clsx'
import DoneIcon from '@mui/icons-material/Done'
import { useEvent } from '@emerald-works/react-event-bus-client'

const getTotalWording = (meteringLimit) => {
  const allUnitsUsed = ['both', 'all']
  return meteringLimit === 2 ? allUnitsUsed[0] : allUnitsUsed[1]
}

const PreviewPaywall = () => {
  const classes = useStyles()
  const { getMtUrl } = useExternalApp()
  const tenant = useTenant()
  const isClubTenant = tenant.pk === consts.DEFAULT_CLUB_PK

  const isExclusive = useSelector(contentSlice.selectors.selectIsExclusive)
  const contentConsumed = useSelector(contentSlice.selectors.selectMeteringUsed)
  const meteringLimit = useSelector(contentSlice.selectors.selectMeteringLimit)
  const totalAmount = getTotalWording(meteringLimit)

  const redirectToSignup = () => {
    window.location.href = getMtUrl('join')
  }
  const [exclusiveSignUpClick] = useEvent([{
    eventName: 'exclusiveSignUpClick',
    onSuccess: redirectToSignup,
    onError: redirectToSignup
  }])

  const handleExclusiveSignupClick = () => {
    exclusiveSignUpClick.trigger({
      contentConsumed,
      meteringLimit
    })
  }

  const title = isExclusive ? 'This premium resource is exclusive to Mindtools Members.' : `You've used ${totalAmount} of your free resources.`
  const message = isExclusive
    ? `
  Our members enjoy unparalleled access to thousands of training resources, 
  covering a wide range of topics, all designed to help you develop your management and leadership skills`
    : 'At your own pace,all in one place'

  if (!isClubTenant) return null

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.transparentContainer} />
      <Box className={clsx(classes.messageContainer, isExclusive && classes.messageContainerExclusive)}>
        <Box className={classes.titleContainer}>
          <Typography variant='h5' className={classes.title}>{title}</Typography>
          <Typography variant='body1' className={classes.subtitle}>To continue, you will need to either login or join Mindtools.</Typography>
        </Box>
        <Box className={clsx(classes.messageBorder, isExclusive && classes.messageBorderExclusive)}>
          <Box className={clsx(classes.message, isExclusive && classes.messageExclusive)}>
            <Typography variant='body1' className={clsx(classes.meteringMessageHeading, !isExclusive && classes.bold)}>{message}</Typography>
            {!isExclusive &&
              <Grid display='flex' alignItems='flex-start' flexDirection='column'>
                <Grid item className={classes.messageItem}><DoneIcon /><Typography variant='body1' className={classes.meteringMessage}>On-demand access to thousands of training resources</Typography></Grid>
                <Grid item className={classes.messageItem}><DoneIcon /><Typography variant='body1' className={classes.meteringMessage}>Practical tools to develop essential management and leadership skills</Typography></Grid>
                <Grid item className={classes.messageItem}><DoneIcon /><Typography variant='body1' className={classes.meteringMessage}>Learn online, anywhere - no need to wait for a course</Typography></Grid>
              </Grid>}
          </Box>
        </Box>
        <Box className={clsx(classes.actionButtonContainer, isExclusive && classes.actionButtonContainerExclusive)}>
          <ActionButton
            className={classes.actionButton}
            variant='primary'
            label='Join Today'
            onClick={handleExclusiveSignupClick}
          />
          <Typography className={classes.ctaSubTitle} variant='body2'>Already a member? <Link className={classes.ctaLink} to='/login'>Login now</Link></Typography>
        </Box>

      </Box>
    </Box>
  )
}

export default PreviewPaywall
